import React, { useState } from "react";
import LinkModal from "./LinkModal";

const Link = ({
	customComponent,
	onChange,
	isActive,
	isDisabled,
	prevHref,
	prevNewTab
}) => {
	const [linkModal, setLinkModal] = useState(false);
	const addLink = (url, newTab) => {
		if (onChange) onChange(url, newTab);
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={() => setLinkModal(true)}
				title="Link"
				type="button"
				disabled={isDisabled}
			>
				{customComponent ? customComponent : <i className="fas fa-link" />}
			</button>
			{linkModal && (
				<LinkModal
					linkModal={linkModal}
					setLinkModal={setLinkModal}
					setHyperLink={addLink}
					prevHref={prevHref}
					prevNewTab={prevNewTab}
				/>
			)}
		</>
	);
};

export default Link;
